// extracted by mini-css-extract-plugin
export var borderRadius = "_f5-4";
export var large = "_f5-3";
export var logoContainer = "_f5-0";
export var nameLogo = "_f5-2";
export var small = "_f5-1";